module.exports = __webpack_public_path__ + "static/media/keynote.632684a1.svg";